<template>
  <div>
    <ImportAndBalanceTab />
  </div>
</template>
<script>
import ImportAndBalanceTab from '../../../../components/tax/SpecialTaxItems/newTaxRoll/importAndBalance.vue';

export default {
  name: 'ImportAndBalance',
  components: {
    ImportAndBalanceTab,
  },
};
</script>
